<template>
    <div class="system" id="sys">
        <Header />
        <main class="main page" id="main">
            <router-view />
        </main>
    </div>
</template>

<script>
import Header from "./components/Header.vue";
export default {
    components: {
        Header
    }
}
</script>

<style lang="less" scoped>
.system {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #000;
    transition: all 0.2s ease;

    .main {
        margin: 0 auto;
        max-width: 1920px;
        background: #2B2B30;
    }
}
</style>